import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';

import { IonicModule } from '@ionic/angular';

import { EventDetailsPageRoutingModule } from './event-details-routing.module';

import { EventDetailsPage } from './event-details.page';
import { HeaderModule, FooterModule, LoadingIndicatorModule } from 'src/app/shared';
import { EventCardGridModule } from 'src/app/shared/components/event-card-grid';

import { Routes, RouterModule } from '@angular/router';
import { HomePage } from '../home/home.page';

const routes: Routes = [{ path: 'home', component: HomePage }];

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    IonicModule,
    EventDetailsPageRoutingModule,
    HeaderModule,
    FooterModule,
    LoadingIndicatorModule,
    EventCardGridModule,
    RouterModule.forChild(routes),
  ],
  declarations: [EventDetailsPage],
  schemas: [CUSTOM_ELEMENTS_SCHEMA]
})
export class EventDetailsPageModule {}
